import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, FormGroup, ValidationErrors } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { AppState } from '../store';
import * as fromProcess from '../store/process/process.reducer';
import { findFirstFormGroup } from '../utils';

const REQUEST_DEBOUNCE_TIME = 100;

@Injectable({ providedIn: 'root' })
export class AsyncAgentNumberValidator implements AsyncValidator {
  constructor(private apiService: ApiService, private store: Store<AppState>) {}

  validate(control: AbstractControl<string>, controlNameToModify?: string): Observable<ValidationErrors | null> {
    return this.apiService.getAgentNumberForValidation(control.value, this.store.selectSignal(fromProcess.selectProcessKind)()).pipe(
      debounceTime(REQUEST_DEBOUNCE_TIME),
      map((response) => {
        const result = response.result;
        const requestedAgent = result.find((agent) => agent.agentNumber === String(control.value));

        if (controlNameToModify) {
          const group: FormGroup<any> = findFirstFormGroup(control) as FormGroup;

          const agentName =
            requestedAgent?.firstName || requestedAgent?.lastName
              ? `${requestedAgent?.firstName ?? ''} ${requestedAgent?.lastName ?? ''}`
              : `${requestedAgent?.agentDisplayName ?? ''}`;

          group.get(controlNameToModify)?.setValue(agentName, { emitEvent: false });
        }

        return requestedAgent ? null : { missingAgent: true };
      }),
      catchError(() => of({ missingAgent: true })),
    );
  }
}
